import { render } from "./CashierSessionLogout.vue?vue&type=template&id=54f08520&ts=true"
import script from "./CashierSessionLogout.vue?vue&type=script&lang=ts"
export * from "./CashierSessionLogout.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__